import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  oneParkTab: {
    background: theme.palette.primary.main,
    color: "#fff",
  },
  subHeader: {
    backgroundColor: theme.palette.background.level2 || theme.palette.grey[100],
    padding: theme.spacing(1, 2),
  },
}));

export default useStyles;
